import * as React from "react";
import { lazy, Suspense } from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";

//import "regenerator-runtime/runtime.js";
//import { Provider as ReduxProvider } from "react-redux";

const NewsListing = lazy(() => import("./components/newsListing"));
const FormComponent = lazy(() => import ("./components/formBuilder/formComponent"));
//const FormModalComponent = lazy(() => import ("./components/formBuilder/formModalComponent"));
//const HomeFormModalComponent = lazy(() => import ("./components/formBuilder/homeFormModalComponent"));
//import LoadingIndicator from "./components/LoadingIndicator";
//const JobsSearchRedirect = lazy(() => import("./components/JobsSearchRedirect"));
//const AwardsPage = lazy(() => import("./components/AwardsPage"));
//const BlogPage = lazy(() => import("./components/BlogPage"));
//const EBooksPage = lazy(() => import("./components/EBooksPage"));
//const CaseStudiesPage = lazy(() => import("./components/CaseStudiesPage"));
//const JobsSearchPage = lazy(() => import("./components/JobsSearchPage"));
//import configureStore from './store/configureStore';

//const store = configureStore(history);
const globalAny: any = global;
//globalAny.bootstrap = bootstrap;

globalAny.React = React;
globalAny.ReactDOM = ReactDOM;
globalAny.ReactDOMClient = ReactDOMClient;

globalAny.NewsListing = (props: any) => (<Suspense fallback={<>Loading..</>}><NewsListing {...props} /></Suspense>);
globalAny.FormComponent = (props: any) => (<Suspense fallback={<div />}><FormComponent {...props} /></Suspense>);

//globalAny.AwardsPage = (props) => (<Suspense fallback={<LoadingIndicator />}><AwardsPage {...props} /></Suspense>);
//globalAny.EBooksPage = (props) => (<Suspense fallback={<LoadingIndicator />}><EBooksPage {...props} /></Suspense>);
//globalAny.FormComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><FormComponent {...props} /></Suspense>);
//globalAny.FormModalComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><FormModalComponent {...props} /></Suspense>);
//globalAny.HomeFormModalComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><HomeFormModalComponent {...props} /></Suspense>);
//globalAny.LoadingIndicator = LoadingIndicator;
//globalAny.JobsSearchRedirect = (props) => (<Suspense fallback={<LoadingIndicator />}><JobsSearchRedirect {...props} /></Suspense>);
//globalAny.BlogPage = (props) => (<Suspense fallback={<LoadingIndicator />}><BlogPage {...props} /></Suspense>);
//globalAny.CaseStudiesPage = (props) => (<Suspense fallback={<LoadingIndicator />}><CaseStudiesPage {...props} /></Suspense>);
//globalAny.JobsSearchPage = (props) => (<Suspense fallback={<LoadingIndicator />}><ReduxProvider store={store}><JobsSearchPage {...props} /></ReduxProvider></Suspense>);


export default global;